import TashbeekManagement from "./pages/tashbeek-management/store";

export default {
  namespaced: true,
  modules: {
    TashbeekManagement,
  },
};
